export const ENV = process.env.REACT_APP_ENV;
export const VERSION = process.env.REACT_APP_VERSION;

export const MOCKEND_ALL_DISABLED =
  process.env.REACT_APP_MOCKEND_ALL_DISABLED === "true";
export const MOCKEND_ALL_ENABLED =
  process.env.REACT_APP_MOCKEND_ALL_ENABLED === "true";
export const MOCKEND_TIMING = 800;

export const STRIPE_PUBLISHABLE_KEY =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || "";

export const DEFAULT_AGENCY_CODE = process.env.REACT_APP_DEFAULT_AGENCY_CODE;

export const API_NAME = process.env.REACT_APP_API_NAME || "";
export const ENDPOINT = process.env.REACT_APP_ENDPOINT;
export const REGION = process.env.REACT_APP_REGION;

export const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const TOKEN_PATH = process.env.REACT_APP_TOKEN_PATH || "";
export const AUTHFLOW = process.env.REACT_APP_AUTHFLOW || "";
export const USERNAME = process.env.REACT_APP_USERNAME || "";
export const PASSWORD = process.env.REACT_APP_PASSWORD || "";
export const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "";
export const USER_POOL_ID = process.env.REACT_APP_USER_POOL_ID || "";

export const GIVE_BASE_CODE = process.env.REACT_APP_GIVE_BASE_CODE || "";
export const GIVE_PLUS_CODE = process.env.REACT_APP_GIVE_PLUS_CODE || "";
export const MIN_PERIOD = Number(process.env.REACT_APP_MIN_PERIOD) || 1;
export const MAX_PERIOD = Number(process.env.REACT_APP_MAX_PERIOD) || 30;
export const MAX_INSURED = Number(process.env.REACT_APP_MAX_INSURED) || 300;

export const MAX_WIDTH = "3500px";
